const EVENT_SUBTYPES = {
  SETTINGS: 'SETTINGS',
  DETAILS: 'DETAILS',
  UPDATE: 'UPDATE',
  SIMPLE_DETAILS: 'SIMPLE_DETAILS',
  CREATE: 'CREATE',
  REPLACE: 'REPLACE',
  REVERT_REPLACE: 'REVERT_REPLACE',
  UPDATE_KEYWORD: 'UPDATE_KEYWORD',
  COMPONENT_DETAILS_CREATE: 'COMPONENT_DETAILS_CREATE',
  IS_WHOLE_FOOD: 'IS_WHOLE_FOOD',
  OVERRIDES_DETAILS_CREATE: 'OVERRIDES_DETAILS_CREATE',
  EXTRA_DETAILS_PHRASES_CREATE: 'EXTRA_DETAILS_PHRASES_CREATE',
  EXTRA_DETAILS_INGREDIENTS_CREATE: 'EXTRA_DETAILS_INGREDIENTS_CREATE',
  ALTERNATIVE_INGREDIENTS_DETAILS_CREATE:
    'ALTERNATIVE_INGREDIENTS_DETAILS_CREATE',
  RECEIVED_KEYWORD_FROM_DICTIONARY: 'RECEIVED_KEYWORD_FROM_DICTIONARY',
  SENT_DICTIONARY_WORD_TO_INGREDIENT: 'SENT_DICTIONARY_WORD_TO_INGREDIENT',
  RECEIVED_KEYWORD_FROM_INGREDIENT: 'RECEIVED_KEYWORD_FROM_INGREDIENT',
  SENT_KEYWORD_TO_DICTIONARY: 'SENT_KEYWORD_TO_DICTIONARY',
  SENT_KEYWORD_TO_INGREDIENT: 'SENT_KEYWORD_TO_INGREDIENT',
  CREATE_KEYWORD: 'CREATE_KEYWORD',
  CREATE_EXPORTED_KEYWORD: 'CREATE_EXPORTED_KEYWORD',
  IMAGE_DETAILS: 'IMAGE_DETAILS',
  IGNORED_DETAILS: 'IGNORED_DETAILS',
  ADDITIONAL_INGREDIENTS_DETAILS_CREATE:
    'ADDITIONAL_INGREDIENTS_DETAILS_CREATE',
  EXCLUDED_INGREDIENTS_CREATE: 'EXCLUDED_INGREDIENTS_CREATE',
  EXCLUDED_ALLERGENS_CREATE: 'EXCLUDED_ALLERGENS_CREATE',
  INCLUDED_INGREDIENTS_CREATE: 'INCLUDED_INGREDIENTS_CREATE',
  INCLUDED_ALLERGENS_CREATE: 'INCLUDED_ALLERGENS_CREATE',
  DELETE: 'DELETE',
  INCLUDED_ALLERGENS_DELETE: 'INCLUDED_ALLERGENS_DELETE',
  INCLUDED_INGREDIENTS_DELETE: 'INCLUDED_INGREDIENTS_DELETE',
  EXCLUDED_ALLERGENS_DELETE: 'EXCLUDED_ALLERGENS_DELETE',
  EXCLUDED_INGREDIENTS_DELETE: 'EXCLUDED_INGREDIENTS_DELETE',
  ADDITIONAL_INGREDIENTS_DETAILS_DELETE:
    'ADDITIONAL_INGREDIENTS_DETAILS_DELETE',
  ALTERNATIVE_INGREDIENTS_DETAILS_DELETE:
    'ALTERNATIVE_INGREDIENTS_DETAILS_DELETE',
  ALTERNATIVE_INGREDIENTS_DETAILS_UPDATE:
    'ALTERNATIVE_INGREDIENTS_DETAILS_UPDATE',
  DELETE_KEYWORD: 'DELETE_KEYWORD',
  EXTRA_DETAILS_INGREDIENTS_DELETE: 'EXTRA_DETAILS_INGREDIENTS_DELETE',
  EXTRA_DETAILS_PHRASES_DELETE: 'EXTRA_DETAILS_PHRASES_DELETE',
  OVERRIDES_DETAILS_DELETE: 'OVERRIDES_DETAILS_DELETE',
  COMPONENT_DETAILS_DELETE: 'COMPONENT_DETAILS_DELETE',
  CHALLENGE_CUISINE_TYPES_CREATE: 'CHALLENGE_CUISINE_TYPES_CREATE',
  CHALLENGE_CUISINE_TYPES_DELETE: 'CHALLENGE_CUISINE_TYPES_DELETE',
  CHALLENGE_DISH_TYPES_CREATE: 'CHALLENGE_DISH_TYPES_CREATE',
  CHALLENGE_DISH_TYPES_DELETE: 'CHALLENGE_DISH_TYPES_DELETE',
  FOOD_MOOD_DISH_TYPES_CREATE: 'FOOD_MOOD_DISH_TYPES_CREATE',
  FOOD_MOOD_DISH_TYPES_DELETE: 'FOOD_MOOD_DISH_TYPES_DELETE',
}

export default EVENT_SUBTYPES
